/** The clinic's reusable report frames: graph presets and table presets. */
export const PRESET_LIBRARY_KINDS = ["graph", "table"] as const;
export type PresetLibraryKind = (typeof PRESET_LIBRARY_KINDS)[number];

/**
 * BroadcastChannel name for cross-tab library sync. The studio keeps its
 * preset lists fresh when a save lands in a library editor open in another
 * tab (react-query caches are per tab).
 */
export const PRESET_LIBRARY_SYNC_CHANNEL = "klarify:preset-libraries";
